/**
 * 客户端Socket工具类
 */
export default class AppNative {
  public static appid = 0
  public static native = {}
  /** 方法 */
  public static iosNeedMessageFun = {
    buildRequest: 'buildRequest',
    extractResponse: 'extractResponse',
    getUid: 'getUid',
    getTicket: 'getTicket',
    getArea: 'getArea',
    getLanguage: 'getLanguage',
    canClose: 'canClose',
    openChargePage: 'openChargePage',
    getAppVersion: 'getAppVersion',
    getRoomType: 'getRoomType',
    getRoomInfo: 'getRoomInfo',
    closeRoom: 'closeRoom', // IOS房间 IOS房间('1,2') 关闭房间
    startBilling: 'startBilling', // IOS房间 开始计费
    exitChatRoom: 'exitChatRoom', // IOS房间 强制退出房间
    anchorInfo: 'anchorInfo', // IOS房间 获取主播信息
    audienceInfo: 'audienceInfo', // IOS房间 获取用户信息
    socketSend: 'socketSend', // IOS房间 发送socket请求
    call: 'call', // IOS房间电话
    userPopup: 'userPopup', // IOS房间用户弹窗
    giftPopup: 'giftPopup', // IOS房间礼物弹窗
    openChat: 'openChat', // IOS房间打开会话
    roomSharing: 'roomSharing', // IOS房间分享房间
    feedback: 'feedback', // IOS房间用户反馈
    roomMemberKicked: 'roomMemberKicked', // IOS房间被踢出
    roomCloseCover: 'roomCloseCover', // 关闭IOS遮罩层
    openGameList: 'openGameList', // 打开游戏列表
    openManager: 'openManager', // 打开管理页面
    refreshUserData: 'refreshUserData', // 刷新余额
    openLuckRggRule: 'openLuckRggRule', // 打开炸弹规则
    openEnterLiveRoom: 'openEnterLiveRoom', // 让APP去打开直播间
    openEnterGame: 'openEnterGame', // 房间打开游戏
    openRoomGrade: 'openRoomGrade', // 房间打开房间等级
    openRoomRecharge: 'openRoomRecharge', // 房间打开首充弹窗
    openUserInfoCard: 'openUserInfoCard', // 打开用户信息卡
    creatorUpdateQueue: 'creatorUpdateQueue', // 房主更新队列
    showLockMicTips: 'showLockMicTips', // 房间麦克风状态改变
    downMicFinshed: 'downMicFinshed', // 下载麦克风完成
    getAgoraKey: 'getAgoraKey', // 获取AgoraKey
    isOpenMicrophone: 'isOpenMicrophone' // 麦克风打开完成通知
  }
  // 回调参数的方法和值   方法:值,需要回调的要在这设置
  public static iosGetMessageFun = {
    getTicket: 'ticket',
    getUid: 'uid',
    getArea: 'area',
    canClose: 'canClose',
    getLanguage: 'lang',
    openChargePage: 'openChargePage',
    getAppVersion: 'versionCode',
    getRoomType: 'roomType',
    getRoomInfo: 'roomInfo',
    openRechargePopup: 'openRechargePopup',
    anchorInfo: 'anchorInfo',
    audienceInfo: 'audienceInfo',
    refreshUserData: 'refreshUserData',
    getAgoraKey: 'getAgoraKey'
  }

  public static isOnLoad = false
  public static onload = function () {
    AppNative.isOnLoad = true
    window['getMessage'] = function (id, data) {
      AppNative.native[id] && AppNative.native[id](data)
      console.log(id, data)
      delete AppNative.native[id]
    }
  }

  public static isJSONStr(str) {
    if (typeof str == 'string') {
      try {
        const obj = JSON.parse(str)
        if (typeof obj == 'object') {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    } else {
      return false
    }
  }

  public static appFun: any = function () {
    if (!AppNative.isOnLoad) {
      AppNative.onload()
    }

    // eslint-disable-next-line prefer-rest-params
    const arg = arguments
    return new Promise(function (resolve, reject) {
      if (!common.checkVersion().app) {
        return resolve(false)
      }
      const funName: string = Array.prototype.shift.call(arg)
      let appObj: any = {}
      console.log('AppNative => appFun', funName)
      try {
        if (common.checkVersion().ios) {
          appObj = window['webkit']['messageHandlers']
          if (Object.hasOwn(AppNative.iosGetMessageFun, funName)) {
            AppNative.native[AppNative.iosGetMessageFun[funName]] = function (
              data
            ) {
              resolve(data)
            }
            if (arg[0] !== undefined) {
              const data = {
                id: AppNative.appid,
                data: {}
              }
              if (AppNative.isJSONStr(arg[0])) {
                data.data = JSON.parse(arg[0])
              } else {
                data.data = arg[0]
              }
              arg[0] = JSON.stringify(data)
              appObj[funName].postMessage(arg[0])
            } else {
              appObj[funName].postMessage(null)
            }
            AppNative.appid++
          } else {
            let data = {}
            if (AppNative.isJSONStr(arg[0])) {
              data = JSON.parse(arg[0])
            } else {
              data = arg[0]
            }
            arg[0] = JSON.stringify(data)
            if (arg[0] !== undefined) {
              appObj[funName].postMessage(arg[0])
            } else {
              appObj[funName].postMessage(null)
            }
          }
        } else {
          appObj = window['androidJsObj']
          if (arg[0] !== undefined) {
            resolve(appObj[funName](arg[0]))
          } else {
            resolve(appObj[funName]())
          }
        }
      } catch (e) {
        console.log('appFun Error: ', e)
        resolve(false)
      }
    })
  }
}
